import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PoliticaPrivacidade() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Política de Privacidade</h1>
            
            <div className="prose prose-lg max-w-none">
              <div className="mb-6">
                <p className="font-semibold text-gray-900 mb-3">Introdução</p>
                <p className="text-gray-700 mb-6">
                  A 7deOuros valoriza a privacidade de seus clientes e visitantes do site. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD) – Lei nº 13.709/2018.
                </p>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Coleta de Informações</h3>
                <p className="text-gray-700 mb-3">
                  Coletamos informações pessoais que você nos fornece diretamente, como:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>Nome</li>
                  <li>E-mail</li>
                  <li>Telefone</li>
                  <li>Informações fornecidas através do formulário de contato</li>
                </ul>
                <p className="text-gray-700 mb-3">
                  Além disso, podemos coletar informações automaticamente quando você visita nosso site, como:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-6">
                  <li>Endereço IP</li>
                  <li>Dados de navegação (cookies)</li>
                </ul>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Uso das Informações</h3>
                <p className="text-gray-700 mb-3">
                  As informações coletadas são utilizadas para:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-6">
                  <li>Fornecer e melhorar nossos serviços</li>
                  <li>Entrar em contato com você para responder às suas consultas e fornecer suporte</li>
                  <li>Enviar comunicações de marketing, caso você tenha consentido</li>
                  <li>Analisar o uso do site para melhorar a experiência do usuário</li>
                </ul>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Compartilhamento de Informações</h3>
                <p className="text-gray-700 mb-3">
                  Não compartilhamos suas informações pessoais com terceiros, exceto:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-6">
                  <li>Quando exigido por lei</li>
                  <li>Para proteger nossos direitos e propriedades</li>
                  <li>Com prestadores de serviços que auxiliam nas operações do site, sob obrigações de confidencialidade</li>
                </ul>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Armazenamento e Segurança</h3>
                <p className="text-gray-700 mb-6">
                  Armazenamos suas informações pessoais em servidores seguros e adotamos medidas técnicas e organizacionais adequadas para proteger seus dados contra acesso não autorizado, alteração, divulgação ou destruição.
                </p>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Seus Direitos</h3>
                <p className="text-gray-700 mb-3">
                  De acordo com a LGPD, você tem o direito de:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-6">
                  <li>Acessar suas informações pessoais</li>
                  <li>Corrigir informações incompletas, inexatas ou desatualizadas</li>
                  <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos</li>
                  <li>Solicitar a portabilidade dos dados a outro fornecedor de serviço ou produto</li>
                  <li>Revogar o consentimento a qualquer momento</li>
                </ul>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Cookies</h3>
                <p className="text-gray-700 mb-6">
                  Utilizamos cookies para melhorar a funcionalidade do site e a experiência do usuário. Você pode configurar seu navegador para recusar cookies, mas isso pode afetar a disponibilidade de algumas funcionalidades do site.
                </p>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Alterações na Política de Privacidade</h3>
                <p className="text-gray-700 mb-6">
                  Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre quaisquer alterações significativas através do site ou por outros meios de comunicação.
                </p>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Contato</h3>
                <p className="text-gray-700 mb-3">
                  Se você tiver dúvidas ou solicitações relacionadas a esta Política de Privacidade, entre em contato conosco:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-6">
                  <li>Telefone: (44) 98804-7699</li>
                  <li>E-mail: contato@setedeouros.com.br</li>
                </ul>
              </div>

              <div className="pt-6 border-t border-gray-200">
                <p className="text-gray-700">
                  7deOuros<br />
                  São Paulo – SP<br />
                  © 2025 7deOuros. Todos os direitos reservados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}